import { render } from "./DeleteFilesConfirmDialog.vue?vue&type=template&id=2fb736fb"
import script from "./DeleteFilesConfirmDialog.vue?vue&type=script&lang=js"
export * from "./DeleteFilesConfirmDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__